{
  "simulator": {
    "matchFacts": "priority {{priority}}, specificity {{specificity}}"
  },
  "budget": {
    "filterTitle": "Filter budgets",
    "showBudgets": "Show budgets",
    "showCount": "Show budgets: {{count}}",
    "category": "Category"
  },
  "puxTenant": {
    "noMatch": "No budgets match these filters",
    "auditNoMatch": "No audit entries match these filters",
    "rfqStatus": "Enquiry status",
    "rfqOnly": "Applies to enquiries only; unsourced needs remain visible.",
    "sourcingNoMatch": "No sourcing work matches these filters",
    "approvalSearch": "Search by request number or requester",
    "approvalSearchPlaceholder": "Request number or requester",
    "approvalAttention": "Attention",
    "approvalOverdue": "Overdue only",
    "approvalDelegated": "On behalf of others only",
    "approvalNoMatch": "No approvals match these filters",
    "copyFailed": "Copy is unavailable. Select the reference and copy it.",
    "rfqStates": {
      "draft": "Draft",
      "open": "Open",
      "awarded": "Awarded",
      "no_award": "No award",
      "cancelled": "Cancelled"
    },
    "deliveryExceptions": "Delivery exceptions"
  }
}
